import { ISO4217 } from '@alk/currency';
import { ISO8601 } from '@alk/dates';

export const EVENT_DATA_01 = {
    checkDateUtc: '2023-01-27T14:05:01.992485Z' as ISO8601,
    clientShortName: '"2062118"',
    data: [
        {
            currency: 'CHF' as ISO4217,
            lastUpdate: '2023-01-06T14:45:56.93694Z' as ISO8601,
            leftLimit: 0,
            limit: 0,
            name: '1Y',
            tradingEnabled: false,
        },
        {
            currency: 'CHF' as ISO4217,
            lastUpdate: '2022-02-04T16:14:58.94964Z' as ISO8601,
            leftLimit: 1_000_000,
            limit: 1_000_000,
            name: '5D',
            tradingEnabled: true,
        },
    ],
    traceId: '2062118:2023-01-27T14:05:01.979Z',
};
